module.exports = __webpack_public_path__ + "img/icon-maximize-2.831d6ef5.svg";